import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export function CloseButton(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(Button, {
    icon: "x",
    variant: "transparent",
    onClick: onClick,
    title: t('actions_close_modal')
  });
}